import { Entity, formatTicker } from '@toggle/toggle';
import React from 'react';

import { EllipsisDetector } from '~/components/elipsis-detector/EllipsisDetector';

import { AssetLogoContainer } from '../asset-logo-container/AssetLogoContainer';
import * as S from './AssetHeader.styles';

export interface AssetHeaderProps {
  entity: Entity;
}

export const AssetHeader = ({ entity }: AssetHeaderProps) => {
  const entityName = entity.name_short || entity.name_full;
  const formattedTicker = formatTicker(entity);

  return (
    <S.StyledEntityDetails
      data-testid="asset-header"
      entityNameComponent={
        <EllipsisDetector label={entityName}>
          <S.Name data-testid="asset-header-title">{entityName}</S.Name>
        </EllipsisDetector>
      }
      formattedTicker={formattedTicker}
      leftImgNode={<AssetLogoContainer entity={entity} />}
    />
  );
};
